import { render } from "./BusinessEnforcement.vue?vue&type=template&id=68606b8d&scoped=true"
import script from "./BusinessEnforcement.vue?vue&type=script&lang=js"
export * from "./BusinessEnforcement.vue?vue&type=script&lang=js"

import "./BusinessEnforcement.vue?vue&type=style&index=0&id=68606b8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68606b8d"]])

export default __exports__